<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)">
        <p-accordionTab header="{{ 'CANALES.LBL_INFOCANAL' | translate }}" [selected]="tabSeleccionado === 'INFO'">
          <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fCanales" name="fCanales">
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'CANALES.LBL_CODIGO' | translate }}</label>
                  <input type="text" pInputText id="codigo"
                         name="nomCodigo"
                         autocomplete="off"
                         formControlName="codigo"
                         maxlength="10"
                         (blur)="validarCodigo()"
                         codigos-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                    {{ 'CANALES.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                    {{ 'CANALES.MSG_CODIGOEXISTE' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'CANALES.LBL_NOMBRE' | translate }}</label>
                  <input type="text" pInputText id="nombre"
                         name="nomNombre"
                         autocomplete="off"
                         formControlName="nombre"
                         [maxlength]="100"
                         capitalize-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                    {{ 'CANALES.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid form-group" *ngIf="lisTipoCanal.length>0">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'CANALES.LBL_TIPOCANAL' | translate }}</label>
                  <p-dropdown disableTab  id="idTipoCanal" name="nomTipoCanal" [options]="lisTipoCanal"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                               formControlName="idTipoCanal"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value"
                              optionLabel="label"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoCanal.invalid">
                    {{ 'CANALES.LBL_TIPOCANAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'CANALES.LBL_CODIGOSHIVAM' | translate }}</label>
                  <input type="text" pInputText id="codigoShivam"
                         name="nomCodigoShivam"
                         autocomplete="off"
                         formControlName="codigoShivam"
                         maxlength="10"
                         (blur)="validarCodigoShivam()"
                         codigos-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigoShivam.invalid">
                    {{ 'CANALES.LBL_CODIGOSHIVAM' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="codShivamExiste">
                    {{ 'CANALES.MSG_CODIGOEXISTE' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <p-checkbox label="{{ 'CANALES.LBL_HABILITADO' | translate}}" binary="true"
                            id="indicador"
                            name="nomIndicador"
                            formControlName="indicadorHabilitado"></p-checkbox>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <p-checkbox label="{{ 'CANALES.LBL_DINERO' | translate}}" binary="true"
                            id="idIndicadorDinero"
                            name="nomIndicadorDinero"
                            formControlName="indicadorDinero"></p-checkbox>
              </div>
            </div>

            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <p-checkbox label="{{ 'CANALES.LBL_RESTRICCIONGESTION' | translate}}" binary="true"
                            id="idIndicadorRestriccionGestion"
                            name="nomIndicadorRestriccionGestion"
                            formControlName="indicadorRestriccionGestion"></p-checkbox>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <p-checkbox label="{{ 'CANALES.LBL_ACTUALIZACIONDATOSDECONTACTO' | translate}}" binary="true"
                            id="idIndicadorRestriccionGestion"
                            name="nomIndicadorRestriccionGestion"
                            formControlName="indicadorActDatosTercero"></p-checkbox>
              </div>
            </div>

            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <p-checkbox label="{{ 'CANALES.LBL_OTPNUMEROTELEFONO' | translate}}" binary="true"
                            id="idIndicadorRestriccionGestion"
                            name="nomIndicadorRestriccionGestion"
                            formControlName="indicadorTelefonoOtp"></p-checkbox>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <p-checkbox label="{{ 'CANALES.LBL_OTPCORREOELECTRONICO' | translate}}" binary="true"
                            id="idIndicadorRestriccionGestion"
                            name="nomIndicadorRestriccionGestion"
                            formControlName="indicadorCorreoOtp"></p-checkbox>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <p-checkbox label="{{ 'CANALES.LBL_SCORE' | translate}}" binary="true"
                            id="indicadorScore"
                            name="indicadorScore"
                            formControlName="indicadorScore"></p-checkbox>
              </div>
            </div>
            <div class="grid">
              <div class="col-12 md:col-12 lg:col-12" style="margin-left: 7px" >
                <strong>{{ 'PRODUCTO.LBL_FUERZACOMERCIAL' | translate }}</strong>
              </div>
            </div>
            <div class="grid form-group">
                <div class="col-12 md:col-3 lg:col-3">
                  <div class="div-form">
                    <p-checkbox label="{{'CANALES.LBL_EJECUTIVO' | translate}}" binary="true"
                                id="indicadorEjecutivo"
                                name="nomIndicadorEjecutivo"
                                formControlName="indicadorEjecutivo"></p-checkbox>
                  </div>
                </div>


                <div class="col-12 md:col-3 lg:col-3">
                  <div class="div-form">
                    <p-checkbox label="{{'CANALES.LBL_FREELANCE' | translate}}" binary="true"
                                id="indicadorFreelance"
                                name="indicadorFreelance"
                                formControlName="indicadorFreelance"></p-checkbox>
                  </div>
                </div>
              </div>


            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <div *ngIf="!guardando">
                  <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                  <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                          type="submit"
                          pButton></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>
            </div>
          </form>
        </p-accordionTab>
        <p-accordionTab header="{{ 'CANALES.LBL_PRODUCTOS' | translate }}" [selected]="tabSeleccionado === 'PRO'" [disabled]="!canal">
          <app-canales-productos [canal]="canal" *ngIf="canal && canal.idCanal"
                                 (dismiss)="cambiarTabSeleccionado($event)"></app-canales-productos>
        </p-accordionTab>
        <p-accordionTab header="{{ 'CANALES.LBL_ROLES' | translate }}" [selected]="tabSeleccionado === 'ROL'" [disabled]="!canal">
          <app-canales-roles [canal]="canal" *ngIf="canal && canal.idCanal"></app-canales-roles>
        </p-accordionTab>

        <!-- TAB Restricción de Gestión por Estados -->
        <p-accordionTab header="{{ 'CANALES.LBL_RESTRICCIONGESTIONXESTADOS' | translate }}"
                        [selected]="tabSeleccionado === 'RESGESXEST'"
                        [disabled]="!canal"
                        *ngIf="canal && canal.indicadorRestriccionGestion"
                        >
                        <app-canales-restricciones-gestion-estados *ngIf="canal && canal.idCanal" [canal]="canal" [esDetalle]="false"></app-canales-restricciones-gestion-estados>
        </p-accordionTab>
      </p-accordion>
      <div class="grid form-footer-buttons" *ngIf="canal && canal.idCanal">
        <div class="form-group col-12">
          <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                  pButton (click)="regresar(false)"></button>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
